module.exports = __webpack_public_path__ + "img/gongsidongtai.bc6b6aeb.jpg";